import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const refresh = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; }
    catch { setUser(false); return false; }
  };
  useEffect(() => { refresh(); }, []);
  const logout = async () => { try { await api.post("/auth/logout"); } catch (e) { console.debug("Logout request failed, clearing session locally:", e); } setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}
